import * as CSS from 'csstype';

export const chameleon = 'inherit';

// orange
export const heritage = '#fe5f50';
export const sandyButt = '#f6caa2';

//red
export const risingSun = '#ce283D';
export const littlePiggy = '#f0a9b7';

// purple
export const berlinThing = '#752873';
export const lavendork = '#b36ea7';

// blue
export const pacific = '#1f3ca6';
export const carnaval = '#81a3e6';

//green
export const forrestLyf = '#2f9780';
export const mildredsCar = '#a4d2d4';

// brown
export const looseAlmond = '#95837b';
export const theTanTan = '#cbbba5';

// neutrals
export const grey800 = '#313030';
export const grey700 = '#5b5a58';
export const grey600 = '#6e6d6c';
export const grey500 = '#969694';
export const grey300 = '#dad9d7';
export const grey100 = '#f3f2f0';
export const white = '#ffffff';

export const semantic = {
    success: forrestLyf,
    error: risingSun,
    info: grey800,
    caution: berlinThing,
    callout: heritage,
    active: heritage,
};

export const typography = {
    root: grey800,
    heading: grey800,
    linkText: pacific,
    small: grey500,

    blockquote: {
        base: 'inherit',
        cite: grey500,
    },

    attribution: grey700,
    displayName: grey800,
    hr: grey800,
    soft: grey700,
    softer: grey500,
    softText: grey500,
    softIcon: grey300,
    softIconFocus: grey500,
    actionHover: pacific,
    contentBorder: grey300,
    contentBackground: white,
};

export const vivid = {
    heritage,
    sandyButt,
    risingSun,
    littlePiggy,
    berlinThing,
    lavendork,
    pacific,
    carnaval,
    forrestLyf,
    mildredsCar,
    looseAlmond,
    theTanTan,
};

export const social = {
    twitter: '#55acee',
    facebook: '#3b5998',
    pinterest: '#bd081c',
    linkedin: '#0077b5',
};

export const packages = {
    bronze: '#e0b48c',
    silver: '#b2b2b2',
    gold: '#e8b954',
    platinum: grey800,
    custom: carnaval,
};

export const withAlpha = (color: string, alpha: number): string => {
    if (alpha < 0 || alpha > 100) {
        return color;
    }
    const alphaHex = '0'.concat(alpha.toString(16)).slice(-2);

    return `${color}${alphaHex}`;
};

export const getColor = (color: CSS.Property.Color | Color) => {
    const exists = color in colors;
    if (exists) return colors[color as Color];
    return color;
};

export type Color =
    | 'chameleon'
    | 'heritage'
    | 'sandyButt'
    | 'risingSun'
    | 'littlePiggy'
    | 'berlinThing'
    | 'lavendork'
    | 'pacific'
    | 'carnaval'
    | 'forrestLyf'
    | 'mildredsCar'
    | 'looseAlmond'
    | 'theTanTan'
    | 'grey800'
    | 'grey700'
    | 'grey600'
    | 'grey500'
    | 'grey300'
    | 'grey100'
    | 'white';

const colors = {
    // Named
    chameleon,
    heritage,
    sandyButt,
    risingSun,
    littlePiggy,
    berlinThing,
    lavendork,
    pacific,
    carnaval,
    forrestLyf,
    mildredsCar,
    looseAlmond,
    theTanTan,
    grey800,
    grey700,
    grey600,
    grey500,
    grey300,
    grey100,
    white,

    // Groups
    semantic,
    typography,
    vivid,
    social,
    packages,

    withAlpha,
};

export default colors;
